module.exports = __webpack_public_path__ + "static/media/COS_HALEON_GSK.980a1322.png";